import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './NTVRotatedDiagonalHotspot.scss';
import {
  TRAVEL_TIMES,
  ROTATED_DIAGONAL_CONFIGS,
  HOTSPOT_RENDER_ORDER,
  getMediaHotspotIcon,
  splitHotspotTitle,
} from '../constants';

const NTVRotatedDiagonalHotspot = ({ media }) => {
  const config = ROTATED_DIAGONAL_CONFIGS[media?._id];
  const rotationAngle = config?.angle;
  const travelTime = TRAVEL_TIMES[media?._id];

  // Render order based on HOTSPOT_RENDER_ORDER index
  const renderOrderIndex = HOTSPOT_RENDER_ORDER.indexOf(media?._id);
  const zIndex = renderOrderIndex >= 0 ? renderOrderIndex + 1 : 0;

  const { firstLine, secondLine } = splitHotspotTitle(media?.title, media?._id);

  const titleClass =
    config?.offsetX !== undefined
      ? `ntv-rotated-diagonal-hotspot__title ntv-rotated-diagonal-hotspot__title--custom-offset`
      : `ntv-rotated-diagonal-hotspot__title ntv-rotated-diagonal-hotspot__title--position-${rotationAngle}`;

  return (
    <div className="ntv-rotated-diagonal-hotspot" style={{ zIndex }}>
      <div
        className={`ntv-rotated-diagonal-hotspot__container ntv-rotated-diagonal-hotspot__container--rotate--${rotationAngle}`}
        style={{
          '--rotation-angle': `${rotationAngle}deg`,
          '--offset': '14px',
          height: `${140 * (media?.height || 1)}px`,
        }}
      >
        <div className={`ntv-rotated-diagonal-hotspot__line ${media?._id}`} />
        <div
          className={titleClass}
          style={
            config?.offsetX !== undefined
              ? {
                  '--custom-offset-x': `${config.offsetX}px`,
                  '--custom-offset-y': `${config.offsetY}px`,
                }
              : undefined
          }
        >
          <div className="ntv-rotated-diagonal-hotspot__title">
            <div className="ntv-rotated-diagonal-hotspot__title-inner">
              <div className="ntv-rotated-diagonal-hotspot__texts">
                {getMediaHotspotIcon(media?._id) ? (
                  <FontAwesomeIcon
                    icon={getMediaHotspotIcon(media?._id)}
                    className="ntv-rotated-diagonal-hotspot__icon"
                  />
                ) : (
                  <span
                    className="ntv-rotated-diagonal-hotspot__icon"
                    aria-hidden="true"
                  />
                )}
                <div className="ntv-rotated-diagonal-hotspot__text-column">
                  <div className="ntv-rotated-diagonal-hotspot__text">
                    {firstLine}
                  </div>
                  {secondLine && (
                    <div className="ntv-rotated-diagonal-hotspot__text ntv-rotated-diagonal-hotspot__text--line2">
                      {secondLine}
                    </div>
                  )}
                  {travelTime && (
                    <div className="ntv-rotated-diagonal-hotspot__subtitle">
                      {/* {travelTime} */}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NTVRotatedDiagonalHotspot;
